import DataTransferObject from '@/Communication/DataTransferObject';
import ComponentManager from '@/Management/ComponentManager';

export default class RelationColumnDTO extends DataTransferObject {

    public DisplayName: string;

    public Factory: string;

    public IsAssociation: boolean;

    public IsEditable: boolean;

    public IsEnumeration: boolean;

    public Name: string;

    public PossibleValues: Array<any>;

    public TypeName: string;

    constructor() {
        super({ xmlProperties: ['DisplayName', 'Factory', 'IsAssociation', 'IsEditable', 'IsEnumeration', 'Name', 'PossibleValues', 'TypeName'] });

        this.DisplayName = this.defaultFromType('string');
        this.Factory = this.defaultFromType('string');
        this.IsAssociation = this.defaultFromType('bool');
        this.IsEditable = this.defaultFromType('bool');
        this.IsEnumeration = this.defaultFromType('bool');
        this.Name = this.defaultFromType('string');
        this.PossibleValues = this.defaultFromType('array');
        this.TypeName = this.defaultFromType('string');
    }
}

ComponentManager.setModel('RelationColumnDTO', RelationColumnDTO, 'RADPresentation.HTMLClient.DefaultViewExtensions');